//imports
import {
    DASHBOARD_PANEL_DELETE_OPEN_MODAL,
    DASHBOARD_PANEL_DELETE_REQUEST,
    DASHBOARD_PANEL_DELETE_RESULT,
    CLEAR_REDUX,
} from 'Redux/actionTypes';

//initial values
const INIT_STATE = {
    openModal: false,
    panel: null,
    loading: false,
    result: null,
};


//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case DASHBOARD_PANEL_DELETE_OPEN_MODAL:
            return { ...state, openModal: action.payload.open, panel: action.payload.data }

        case DASHBOARD_PANEL_DELETE_REQUEST:
            return { ...state, loading: true }

        case DASHBOARD_PANEL_DELETE_RESULT:
            return { ...state, loading: false, result: action.payload.data }

        case CLEAR_REDUX:
            return ["", "DASHBOARD_PANEL_DELETE"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};